<div class="cmx-shell">

  <!-- ===== CABEÇALHO (mesma moldura do vínculo NF × pedido) ===== -->
  <header class="cmx-toolbar">
    <span class="cmx-header-icone">
      <mat-icon class="material-symbols-outlined">compare_arrows</mat-icon>
    </span>
    <div class="cmx-toolbar__title">
      <h2 class="cmx-titulo">Comparação de propostas</h2>
      <div class="cmx-subtitulo">Escolha o fornecedor de cada produto. Pode misturar.</div>
    </div>
    <div class="cmx-criterio">
      <mat-form-field appearance="outline" class="cmx-form-field" subscriptSizing="dynamic">
        <mat-select [(ngModel)]="criterio" (ngModelChange)="onCriterioChange()">
          @for (c of criterios; track c.id) {
            <mat-option [value]="c.id">{{ c.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <button mat-icon-button type="button" class="cmx-header-btn" (click)="alternarTamanho()"
      [matTooltip]="isMaximizado ? 'Restaurar' : 'Maximizar'" [attr.aria-label]="isMaximizado ? 'Restaurar' : 'Maximizar'">
      <mat-icon class="material-symbols-outlined">{{ isMaximizado ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
    <button mat-icon-button type="button" class="cmx-header-btn" (click)="close()" matTooltip="Fechar" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </header>

  <!-- ===== STATUS STRIP ===== -->
  <div class="cmx-status">
    <span class="cmx-pill">
      <span class="cmx-pill__ico cmx-pill__ico--neutral"><mat-icon class="material-symbols-outlined">storefront</mat-icon></span>
      <span class="cmx-pill__text">
        <span class="cmx-pill__value">{{ respondedCount() }}/{{ suppliers.length }}</span>
        <span class="cmx-pill__label">Fornecedores</span>
      </span>
    </span>
    <span class="cmx-vsep cmx-vsep--tall"></span>
    <span class="cmx-pill">
      <span class="cmx-pill__ico cmx-pill__ico--neutral"><mat-icon class="material-symbols-outlined">inventory</mat-icon></span>
      <span class="cmx-pill__text">
        <span class="cmx-pill__value">{{ products.length }}</span>
        <span class="cmx-pill__label">Produtos</span>
      </span>
    </span>
    <span class="cmx-vsep cmx-vsep--tall"></span>
    <span class="cmx-pill">
      <span class="cmx-pill__ico cmx-pill__ico--info"><mat-icon class="material-symbols-outlined">auto_awesome</mat-icon></span>
      <span class="cmx-pill__text">
        <span class="cmx-pill__value">R$ {{ fmt(suggestedTotal()) }}</span>
        <span class="cmx-pill__label">Combinação ideal</span>
      </span>
    </span>
    @if (!hasNoSelections()) {
      <span class="cmx-vsep cmx-vsep--tall"></span>
      <span class="cmx-pill">
        <span class="cmx-pill__ico cmx-pill__ico--brand"><mat-icon class="material-symbols-outlined">shopping_cart_checkout</mat-icon></span>
        <span class="cmx-pill__text">
          <span class="cmx-pill__value">R$ {{ fmt(selectedTotal()) }}</span>
          <span class="cmx-pill__label">Sua seleção</span>
        </span>
      </span>
    }
    <span class="cmx-spacer"></span>
    @if (hasSuggestion()) {
      <button mat-stroked-button type="button" class="btn-secondary" (click)="applySuggestion()"
        [matTooltip]="hasNoSelections() ? '' : 'Substitui a seleção atual pela melhor combinação do critério'">
        <mat-icon class="material-symbols-outlined">auto_awesome</mat-icon>
        Aplicar sugestão automática
      </button>
    }
  </div>

  <!-- ===== MATRIX + PAINEL DE EDIÇÃO ===== -->
  <div class="cmx-content">
  <div class="cmx-body">
    @if (suppliers.length && products.length) {
    <div class="cmx-grid-wrap" [style.max-width]="contentMaxWidth">
      <div class="cmx-grid" [style.grid-template-columns]="gridColumns" [style.min-width]="gridMinWidth">

        <!-- Top-left corner -->
        <div class="cmx-corner">Produto</div>

        <!-- Supplier headers -->
        @for (s of suppliers; track s.id) {
          <div class="cmx-head" [class.cmx-head--editing]="editingSupplierId === s.id">
            <div class="cmx-head__row">
              <span class="cmx-avatar" [style.background]="s.color">{{ s.initials }}</span>
              <div class="cmx-head__info">
                <div class="cmx-head__name">{{ s.name }}</div>
                <div class="cmx-head__meta">
                  <span>{{ s.tag }}</span>
                  @if (foiAjustado(s.id)) {
                    <span class="cmx-dotsep">·</span>
                    <span class="cmx-head__tocado"
                      matTooltip="Você alterou dados desta cotação. Ao aplicar, ela passa a constar como registrada manualmente.">
                      <mat-icon class="material-symbols-outlined">edit</mat-icon>
                      ajustado
                    </span>
                  }
                  @if (winCount(s.id) > 0) {
                    <span class="cmx-dotsep">·</span>
                    <span class="cmx-head__win" [matTooltip]="'Menor preço em ' + winCount(s.id) + ' de ' + products.length + ' produtos'">
                      <mat-icon class="material-symbols-outlined">trending_down</mat-icon>
                      {{ winCount(s.id) }}/{{ products.length }}
                    </span>
                  }
                  @if (selectedCount(s.id) > 0) {
                    <span class="cmx-dotsep">·</span>
                    <span class="cmx-head__sel" [matTooltip]="selectedCount(s.id) + ' produtos escolhidos deste fornecedor'">
                      <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
                      {{ selectedCount(s.id) }}
                    </span>
                  }
                </div>
              </div>
              <button type="button" mat-icon-button class="cmx-electall" (click)="electAll(s.id)"
                matTooltip="Eleger este fornecedor para todos os produtos onde atende">
                <mat-icon class="material-symbols-outlined">done_all</mat-icon>
              </button>
              <button type="button" mat-icon-button class="cmx-electall"
                [class.cmx-electall--on]="editingSupplierId === s.id"
                (click)="editingSupplierId === s.id ? closeEditor() : openEditor(s.id)"
                matTooltip="Editar a cotação deste fornecedor (pagamento, frete, prazos, impostos)">
                <mat-icon class="material-symbols-outlined">edit_note</mat-icon>
              </button>
            </div>
          </div>
        }

        <!-- Product rows -->
        @for (p of products; track p.key) {
          <div class="cmx-prod" [class.cmx-prod--chosen]="selections[p.key]">
            <div class="cmx-prod__name">{{ p.name }}</div>
            <div class="cmx-prod__line">
              @if (p.sku) {
                <span class="cmx-mono">{{ p.sku }}</span>
                <span class="cmx-dotsep">·</span>
              }
              <span>solicitado <b>{{ p.qty }} {{ p.unit }}</b></span>
            </div>
            @if (selections[p.key]; as sid) {
              <div class="status-badge badge-vermelho">
                <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
                {{ supplierById(sid)?.name }}
              </div>
            }
          </div>

          @for (s of suppliers; track s.id) {
            @if (isEmpty(s.id, p.key)) {
              <div class="cmx-cell cmx-cell--empty" (click)="fillEmpty(s.id, p.key, p.qty)">
                <mat-icon class="material-symbols-outlined">remove</mat-icon>
                não cotou
              </div>
            } @else {
              <div class="cmx-cell" [class.cmx-cell--split]="hasAlternativa(s.id, p.key)">

                <!-- Metade 1: oferta original -->
                <div class="cmx-half"
                  [class.cmx-half--selected]="isVariantSelected(s.id, p.key, false)"
                  [class.cmx-half--best]="isBest(s.id, p) && !isSelected(s.id, p.key)"
                  (click)="selectFor(p.key, s.id, false)">

                  <button type="button" class="cmx-radio" [class.cmx-radio--on]="isVariantSelected(s.id, p.key, false)"
                    [disabled]="!canSelect(s.id, p.key)"
                    (click)="$event.stopPropagation(); selectFor(p.key, s.id, false)"
                    [matTooltip]="isVariantSelected(s.id, p.key, false) ? 'Selecionado' : 'Escolher a oferta original'">
                    @if (isVariantSelected(s.id, p.key, false)) { <span class="cmx-radio__dot"></span> }
                  </button>

                  <div class="cmx-cell__main">
                    <div class="cmx-cell__price-row">
                      @if (isEditing('price:' + s.id + ':' + p.key)) {
                        <span class="cmx-edit">
                          <input class="cmx-edit__input" type="text" inputmode="decimal" [currencyMask]="moedaMask"
                            [ngModel]="getOffer(s.id, p.key)?.price ?? null"
                            (ngModelChange)="setOfferPrice(s.id, p.key, $event)"
                            (click)="$event.stopPropagation()"
                            (blur)="stopEdit()"
                            (keydown.enter)="stopEdit()"
                            (keydown.escape)="stopEdit()">
                        </span>
                      } @else {
                        <button type="button" class="cmx-num cmx-num--price"
                          [class.cmx-num--best]="isBest(s.id, p)"
                          (click)="$event.stopPropagation(); startEdit('price:' + s.id + ':' + p.key)">
                          @if (displayOfferPrice(s.id, p.key) !== '—') {
                            <span class="cmx-num__prefix">R$</span>
                          }
                          <span>{{ displayOfferPrice(s.id, p.key) }}</span>
                        </button>
                      }
                      <span class="cmx-cell__un">/un</span>
                    </div>
                    <div class="cmx-cell__qty" [class.cmx-cell__qty--partial]="isPartial(s.id, p.key)"
                      matTooltip="Disponibilidade informada pelo fornecedor (só leitura, ao lado). O campo editável é quanto pedir deste fornecedor.">
                      @if (isPartial(s.id, p.key)) {
                        <mat-icon class="material-symbols-outlined">warning</mat-icon>
                      }
                      <span class="cmx-cell__qty-lbl">pedir</span>
                      @if (isEditing('qty:' + s.id + ':' + p.key)) {
                        <input class="cmx-edit__input cmx-edit__input--qty" type="text" inputmode="decimal"
                          [currencyMask]="quantidadeMask"
                          [ngModel]="offerQty(s.id, p.key)"
                          (ngModelChange)="setOfferQty(s.id, p.key, $event)"
                          (click)="$event.stopPropagation()"
                          (blur)="stopEdit()"
                          (keydown.enter)="stopEdit()"
                          (keydown.escape)="stopEdit()">
                      } @else {
                        <button type="button" class="cmx-num cmx-num--qty"
                          (click)="$event.stopPropagation(); startEdit('qty:' + s.id + ':' + p.key)">
                          {{ offerQty(s.id, p.key) }}
                        </button>
                      }
                      <span>· disp. {{ offerDisponibilidade(s.id, p.key) ?? '—' }}</span>
                    </div>
                    @if (impostoItem(s.id, p.key) > 0) {
                      <div class="cmx-cell__tax" matTooltip="IPI + ST informados pelo fornecedor para este item.">
                        <mat-icon class="material-symbols-outlined">percent</mat-icon>
                        +R$ {{ fmt(impostoItem(s.id, p.key)) }} impostos
                      </div>
                    }
                  </div>

                  @if (isBest(s.id, p)) {
                    <span class="status-badge badge-verde" matTooltip="Menor preço da linha">
                      <mat-icon class="material-symbols-outlined">workspace_premium</mat-icon>
                      melhor
                    </span>
                  } @else if (deltaPct(s.id, p) > 0) {
                    <span class="cmx-badge-delta">+{{ deltaPct(s.id, p).toFixed(1) }}%</span>
                  }

                  @if (isSuggested(s.id, p) && !isSelected(s.id, p.key) && !isBest(s.id, p)) {
                    <span class="cmx-ribbon" matTooltip="Sugestão automática pelo critério selecionado">
                      <mat-icon class="material-symbols-outlined">auto_awesome</mat-icon>
                      Sugerido
                    </span>
                  }
                </div>

                <!-- Metade 2: alternativa (só quando o fornecedor ofertou uma) -->
                @if (hasAlternativa(s.id, p.key)) {
                  <div class="cmx-half cmx-half--alt"
                    [class.cmx-half--selected]="isVariantSelected(s.id, p.key, true)"
                    (click)="selectFor(p.key, s.id, true)">

                    <button type="button" class="cmx-radio" [class.cmx-radio--on]="isVariantSelected(s.id, p.key, true)"
                      [disabled]="!canSelectVariant(s.id, p.key, true)"
                      (click)="$event.stopPropagation(); selectFor(p.key, s.id, true)"
                      [matTooltip]="isVariantSelected(s.id, p.key, true) ? 'Selecionado' : 'Escolher a alternativa'">
                      @if (isVariantSelected(s.id, p.key, true)) { <span class="cmx-radio__dot"></span> }
                    </button>

                    <div class="cmx-cell__main">
                      <div class="cmx-half__tag">
                        <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
                        Alternativa
                      </div>
                      <div class="cmx-cell__price-row">
                        <span class="cmx-num cmx-num--price">
                          @if (displayAltPrice(s.id, p.key) !== '—') {
                            <span class="cmx-num__prefix">R$</span>
                          }
                          <span>{{ displayAltPrice(s.id, p.key) }}</span>
                        </span>
                        <span class="cmx-cell__un">/un</span>
                      </div>
                      <div class="cmx-half__name">
                        {{ altLabel(s.id, p.key) }}@if (altMarca(s.id, p.key)) { · {{ altMarca(s.id, p.key) }} }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          }
        }

        <!-- ===== Condições comerciais ===== -->
        <div class="cmx-sectionhead" [style.grid-column]="sectionSpan">
          <span class="cmx-sectionhead__label">
            <mat-icon class="material-symbols-outlined">handshake</mat-icon>
            Condições comerciais
          </span>
        </div>

        <!-- Prazo de entrega — derivado dos itens, reage ao que é editado no painel -->
        <div class="cmx-rowlabel">
          <mat-icon class="material-symbols-outlined">schedule</mat-icon>
          Prazo de entrega
        </div>
        @for (s of suppliers; track s.id) {
          <div class="cmx-comm" [class.cmx-comm--muted]="leadTimeLabel(s.id) === '—'">{{ leadTimeLabel(s.id) }}</div>
        }

        <!-- Forma de pagamento -->
        <div class="cmx-rowlabel">
          <mat-icon class="material-symbols-outlined">payments</mat-icon>
          Forma de pagamento
        </div>
        @for (s of suppliers; track s.id) {
          <div class="cmx-comm" [class.cmx-comm--muted]="paymentLabel(s.id) === '—'">{{ paymentLabel(s.id) }}</div>
        }

        <!-- Frete -->
        <div class="cmx-rowlabel">
          <mat-icon class="material-symbols-outlined">local_shipping</mat-icon>
          Frete
        </div>
        @for (s of suppliers; track s.id) {
          <div class="cmx-comm" [class.cmx-comm--muted]="freteFor(s.id) == null">
            {{ freteFor(s.id) == null ? '—' : 'R$ ' + fmt(freteFor(s.id)!) }}
          </div>
        }

        <!-- Validade da proposta -->
        <div class="cmx-rowlabel">
          <mat-icon class="material-symbols-outlined">event_available</mat-icon>
          Validade da proposta
        </div>
        @for (s of suppliers; track s.id) {
          <div class="cmx-comm" [class.cmx-comm--muted]="validadeLabel(s.id) === '—'">{{ validadeLabel(s.id) }}</div>
        }

        <!-- Impostos (informados pelo fornecedor — IPI + ST, já somados no total) -->
        <div class="cmx-rowlabel">
          <mat-icon class="material-symbols-outlined">percent</mat-icon>
          Impostos
        </div>
        @for (s of suppliers; track s.id) {
          <div class="cmx-comm cmx-comm--stack" [class.cmx-comm--muted]="!(impostosBySupplier(s.id) > 0)"
            matTooltip="IPI + ST informados pelo fornecedor na cotação. Já somados no Total da proposta.">
            @if (impostosBySupplier(s.id) > 0) {
              <span>R$ {{ fmt(impostosBySupplier(s.id)) }}</span>
              @if (impostosBreakdown(s.id).ipi > 0 && impostosBreakdown(s.id).st > 0) {
                <span class="cmx-comm__sub">
                  IPI {{ fmt(impostosBreakdown(s.id).ipi) }} · ST {{ fmt(impostosBreakdown(s.id).st) }}
                </span>
              }
            } @else {
              <span>—</span>
            }
          </div>
        }

        <!-- Encargos (editable) -->
        <div class="cmx-rowlabel cmx-rowlabel--stack">
          <span class="cmx-rowlabel__top">
            <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
            Encargos
            <span class="status-badge badge-azul" matTooltip="Editado pelo comprador. Ex.: frete, taxas adicionais. Soma no Total da proposta.">editável</span>
          </span>
          <span class="cmx-rowlabel__hint">Outros custos estimados pelo comprador (além dos impostos acima)</span>
        </div>
        @for (s of suppliers; track s.id) {
          <div class="cmx-comm cmx-comm--enc">
            @if (isEditing('enc:' + s.id)) {
              <span class="cmx-edit">
                <input class="cmx-edit__input" type="text" inputmode="decimal" [currencyMask]="moedaMask"
                  [ngModel]="encargoFor(s.id)"
                  (ngModelChange)="setEncargo(s.id, $event)"
                  (blur)="stopEdit()"
                  (keydown.enter)="stopEdit()"
                  (keydown.escape)="stopEdit()">
              </span>
            } @else {
              <button type="button" class="cmx-num cmx-num--price" (click)="startEdit('enc:' + s.id)">
                @if (displayEncargo(s.id) !== '—') {
                  <span class="cmx-num__prefix">R$</span>
                }
                <span>{{ displayEncargo(s.id) }}</span>
              </button>
            }
          </div>
        }

        <!-- Totals row -->
        <div class="cmx-totlabel">
          <mat-icon class="material-symbols-outlined">functions</mat-icon>
          Total da proposta
        </div>
        @for (s of suppliers; track s.id) {
          <div class="cmx-tot"
            [class.cmx-tot--selected]="selectedCount(s.id) > 0"
            [class.cmx-tot--cheapest]="isCheapestProposal(s.id) && selectedCount(s.id) === 0">
            <div class="cmx-tot__val">@if (displayTotalBySupplier(s.id) !== '—') { R$ }{{ displayTotalBySupplier(s.id) }}</div>
            @if (isCheapestProposal(s.id) && selectedCount(s.id) === 0) {
              <span class="status-badge badge-verde">
                <mat-icon class="material-symbols-outlined">trending_down</mat-icon>
                Mais barato
              </span>
            }
          </div>
        }
      </div>
    </div>
    } @else {
      <div class="cmx-empty">
        <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
        <div class="cmx-empty__title">Nenhuma cotação para comparar</div>
        <div class="cmx-empty__text">Adicione fornecedores e registre suas propostas para ver a matriz de comparação.</div>
      </div>
    }

    <!-- ===== Selection summary ===== -->
    @if (selectionGroups.length) {
      <div class="cmx-summary" [style.max-width]="contentMaxWidth">
        <span class="cmx-summary__title">
          <mat-icon class="material-symbols-outlined">shopping_cart_checkout</mat-icon>
          Pedido montado
        </span>
        @if (selectionGroups.length > 1) {
          <span class="cmx-summary__split">Split {{ selectionGroups.length }}×</span>
        }
        <span class="cmx-vsep"></span>
        @for (g of selectionGroups; track g.supplier.id) {
          <span class="cmx-summary__group"
            [matTooltip]="g.supplier.name + ' · ' + g.products.length + ' itens'">
            <span class="cmx-avatar cmx-avatar--sm" [style.background]="g.supplier.color">{{ g.supplier.initials }}</span>
            <span class="cmx-summary__sname">{{ g.supplier.name }}</span>
            <span class="cmx-summary__smeta">
              · {{ g.products.length }} {{ g.products.length === 1 ? 'item' : 'itens' }}
              @if (g.partialCount > 0) { <span class="cmx-summary__partial">({{ g.partialCount }} parcial)</span> }
              · R$ {{ fmt(g.total) }}
            </span>
          </span>
        }
        <span class="cmx-spacer"></span>
        @if (savings > 50) {
          <span class="cmx-summary__savings"
            matTooltip="Quanto este split economiza frente a comprar tudo do fornecedor de fonte única mais barato">
            <mat-icon class="material-symbols-outlined">savings</mat-icon>
            economia R$ {{ fmt(savings) }}
          </span>
        }
        @if (selectedImpostos > 0) {
          <span class="cmx-summary__tax"
            matTooltip="IPI + ST informados pelos fornecedores. Não entram no total do pedido — o que é gravado na compra é preço × quantidade.">
            <mat-icon class="material-symbols-outlined">percent</mat-icon>
            + R$ {{ fmt(selectedImpostos) }} impostos
          </span>
        }
        <span class="cmx-summary__totlabel">Total</span>
        <span class="cmx-summary__totval">R$ {{ fmt(grandTotal) }}</span>
      </div>
    }
  </div>

  <!-- ===== PAINEL DE EDIÇÃO DA COTAÇÃO ===== -->
  @if (editingSupplier; as sup) {
    <aside class="cmx-side">
      <div class="cmx-side__head">
        <span class="cmx-avatar cmx-avatar--sm" [style.background]="sup.color">{{ sup.initials }}</span>
        <div class="cmx-side__titles">
          <div class="cmx-side__title">{{ sup.name }}</div>
          <div class="cmx-side__sub">Editando a cotação</div>
        </div>
        <button type="button" mat-icon-button class="cmx-side__nav" (click)="gotoEditor(-1)" matTooltip="Fornecedor anterior">
          <mat-icon class="material-symbols-outlined">chevron_left</mat-icon>
        </button>
        <button type="button" mat-icon-button class="cmx-side__nav" (click)="gotoEditor(1)" matTooltip="Próximo fornecedor">
          <mat-icon class="material-symbols-outlined">chevron_right</mat-icon>
        </button>
        <button type="button" mat-icon-button class="cmx-side__nav" (click)="closeEditor()" matTooltip="Fechar painel">
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      </div>

      <div class="cmx-side__note">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        As alterações valem na hora no comparativo e são gravadas ao clicar em <b>Aplicar à cotação</b>.
      </div>

      <div class="cmx-side__body">
        @if (headerFor(sup.id); as h) {
          <!-- Condições comerciais -->
          <div class="cmx-side__section">
            <mat-icon class="material-symbols-outlined">handshake</mat-icon>
            Condições comerciais
          </div>

          <app-cotacao-parcelas-editor
            [state]="h.pagamento"
            [dataBase]="dataBaseParcelas"
            [formasPagamento]="formasPagamento"
            [compacto]="true"
            (changed)="marcarAjustado(sup.id)">
          </app-cotacao-parcelas-editor>

          <div class="cmx-side__grid">
            <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
              <mat-label>Tipo de frete</mat-label>
              <mat-select [(ngModel)]="h.idTipoFrete" (ngModelChange)="marcarAjustado(sup.id)">
                <mat-option [value]="null">—</mat-option>
                @for (t of tiposFrete; track t.idTipoFrete) {
                  <mat-option [value]="t.idTipoFrete">{{ t.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
              <mat-label>Frete</mat-label>
              <input matInput [currencyMask]="moedaMask" [(ngModel)]="h.valorFrete" (ngModelChange)="marcarAjustado(sup.id)">
            </mat-form-field>

            <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
              <mat-label>Validade (dias)</mat-label>
              <input matInput type="text" inputmode="numeric" [currencyMask]="inteiroMask" [(ngModel)]="h.validadeDias"
                (ngModelChange)="marcarAjustado(sup.id)">
            </mat-form-field>

            <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
              <mat-label>Encargos (R$)</mat-label>
              <input matInput type="text" inputmode="decimal" [currencyMask]="moedaMask" [ngModel]="encargoFor(sup.id)"
                (ngModelChange)="setEncargo(sup.id, $event)">
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
            <mat-label>Observações da cotação</mat-label>
            <textarea matInput rows="2" [(ngModel)]="h.observacoes" (ngModelChange)="marcarAjustado(sup.id)"></textarea>
          </mat-form-field>
        }

        <!-- Itens -->
        <div class="cmx-side__section">
          <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
          Itens da cotação
        </div>

        @for (p of products; track p.key) {
          @if (offers[sup.id][p.key]; as o) {
            <div class="cmx-item" [class.cmx-item--chosen]="isSelected(sup.id, p.key)">
              <div class="cmx-item__head">
                <span class="cmx-item__name">{{ p.name }}</span>
                <span class="cmx-item__req">solicitado {{ p.qty }} {{ p.unit }}</span>
              </div>
              <div class="cmx-side__grid">
                <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
                  <mat-label>Preço unit. (R$)</mat-label>
                  <input matInput type="text" inputmode="decimal" [currencyMask]="moedaMask" [ngModel]="o.price"
                    (ngModelChange)="setOfferPrice(sup.id, p.key, $event)">
                </mat-form-field>

                <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
                  <mat-label>Pedir</mat-label>
                  <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" [ngModel]="o.qty"
                    (ngModelChange)="setOfferQty(sup.id, p.key, $event)">
                </mat-form-field>

                <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
                  <mat-label>Disponibilidade</mat-label>
                  <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" [(ngModel)]="o.disponibilidade"
                    (ngModelChange)="marcarAjustado(sup.id)" placeholder="sem limite">
                </mat-form-field>

                <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
                  <mat-label>Prazo (dias)</mat-label>
                  <input matInput type="text" inputmode="numeric" [currencyMask]="inteiroMask" [(ngModel)]="o.prazoEntregaDias"
                    (ngModelChange)="marcarAjustado(sup.id)">
                </mat-form-field>

                <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
                  <mat-label>IPI (R$)</mat-label>
                  <input matInput type="text" inputmode="decimal" [currencyMask]="moedaMask" [(ngModel)]="o.valorIpi"
                    (ngModelChange)="marcarAjustado(sup.id)">
                </mat-form-field>

                <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
                  <mat-label>ICMS ST (R$)</mat-label>
                  <input matInput type="text" inputmode="decimal" [currencyMask]="moedaMask" [(ngModel)]="o.valorIcmsSt"
                    (ngModelChange)="marcarAjustado(sup.id)">
                </mat-form-field>
              </div>

              <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
                <mat-label>Marca ofertada</mat-label>
                <input matInput [(ngModel)]="o.marcaOfertada" (ngModelChange)="marcarAjustado(sup.id)">
              </mat-form-field>

              <mat-form-field appearance="outline" class="cmx-side__field" subscriptSizing="dynamic">
                <mat-label>Observações do item</mat-label>
                <input matInput [(ngModel)]="o.observacoes" (ngModelChange)="marcarAjustado(sup.id)">
              </mat-form-field>
            </div>
          }
        }
      </div>
    </aside>
  }
  </div>

  <!-- ===== FOOTER ===== -->
  <div class="cmx-footer">
    @if (missingCount() > 0) {
      <span class="cmx-foot-note">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        {{ missingCount() }} {{ missingCount() === 1 ? 'produto sem fornecedor' : 'produtos sem fornecedor' }}
      </span>
    } @else {
      <span class="cmx-foot-note cmx-foot-note--ok">
        <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
        Todos os produtos têm fornecedor escolhido
      </span>
    }
    <span class="cmx-spacer"></span>
    <button mat-stroked-button type="button" class="btn-secondary" (click)="close()">Cancelar</button>
    <button mat-flat-button type="button" class="btn-primary" (click)="apply()"
      matTooltip="Grava preços, quantidades e condições editados, e aplica os fornecedores escolhidos">
      <mat-icon class="material-symbols-outlined">save</mat-icon>
      Salvar alterações
    </button>
  </div>
</div>
